import type { Component } from "svelte";
import IconCoffeeOutline from '~icons/mdi/coffee-outline';
import IconWeatherNight from '~icons/mdi/weather-night';
import IconWeatherSunny from '~icons/mdi/weather-sunny';
import IconWeatherSunset from '~icons/mdi/weather-sunset';

export enum TimeOfDay {
    MORNING = 'MORNING',
    AFTERNOON = 'AFTERNOON',
    EVENING = 'EVENING',
    NIGHT = 'NIGHT',
}

export interface TimeOfDayMeta {
    label: string;
    Icon: Component;
    cssThemeVar: string;
    textColour: string;
    bgColour: string;
}

export const TIME_OF_DAY_METAS: Record<TimeOfDay, TimeOfDayMeta> = {
    [TimeOfDay.MORNING]: {
        label: 'Morning',
        Icon: IconCoffeeOutline,
        cssThemeVar: '--color-tod-morning',
        textColour: 'text-tod-morning',
        bgColour: 'bg-tod-morning'
    },
    [TimeOfDay.AFTERNOON]: {
        label: 'Afternoon',
        Icon: IconWeatherSunny,
        cssThemeVar: '--color-tod-afternoon',
        textColour: 'text-tod-afternoon',
        bgColour: 'bg-tod-afternoon'
    },
    [TimeOfDay.EVENING]: {
        label: 'Evening',
        Icon: IconWeatherSunset,
        cssThemeVar: '--color-tod-evening',
        textColour: 'text-tod-evening',
        bgColour: 'bg-tod-evening'
    },
    [TimeOfDay.NIGHT]: {
        label: 'Night',
        Icon: IconWeatherNight,
        cssThemeVar: '--color-tod-night',
        textColour: 'text-tod-night',
        bgColour: 'bg-tod-night'
    }
};

export const TIME_OF_DAY_ORDER: Record<TimeOfDay, number> = {
    [TimeOfDay.MORNING]: 0,
    [TimeOfDay.AFTERNOON]: 1,
    [TimeOfDay.EVENING]: 2,
    [TimeOfDay.NIGHT]: 3,
};